<template>
    <div class="container-fluid">
        <div v-if="id" class="modal-backdrop fade show"></div>
        <app-create
            v-if="id == 'create'"
            :id="id == 'create'"
            :submit="submit == 'create'"
            @onClose="() => { id = null, submit = null }"
            @onEvent="onCreate">
        </app-create>
        <app-update
            :data="data"
            v-if="id == 'update'"
            :id="id == 'update'"
            :submit="submit == 'update'"
            @onClose="() => { id = null, submit = null }"
            @onEvent="onUpdate">
        </app-update>
        <app-delete
            :data="data"
            v-if="id == 'delete'"
            :id="id == 'delete'"
            :submit="submit == 'delete'"
            @onClose="() => { id = null, submit = null }"
            @onEvent="onDelete">
        </app-delete>
        <div class="card bg-light-info shadow-none position-relative overflow-hidden">
            <div class="card-body px-4 py-3">
                <div class="row align-items-center">
                    <div class="col-9">
                        <h4 class="fw-semibold mb-8">Guias</h4>
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <router-link class="text-muted" :to="{ name: 'Calendar' }">Inicio</router-link>
                                </li>
                                <li class="breadcrumb-item" aria-current="page">
                                    Guias
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div class="col-3">
                        <div class="text-center mb-n5">
                            <img src="@/assets/images/breadcrumb/ChatBc.png" alt="" class="img-fluid mb-n4" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="border-bottom title-part-padding">
                        <h4 class="card-title mb-0">Lista de guias</h4>
                    </div>
                    <div class="card-body">
                        <div class="d-flex justify-content-between align-items-center mb-9">
                            <div class="d-flex gap-2">
                              <div class="position-relative">
                                <input type="text" class="form-control search-chat py-2 ps-5" v-model="search" placeholder="Buscador usuario">
                                <i class="ti ti-search position-absolute top-50 start-0 translate-middle-y fs-6 text-dark ms-3"></i>
                              </div>
                              <button type="button" @click="onSearch" class="btn btn-primary">
                                Buscar
                              </button>
                              <button type="button" @click="onClear" class="btn btn-danger">
                                Limpiar
                              </button>
                              <button type="button" @click="onSort" class="btn btn-dark">
                                <i class="me-2" :class="sort == 'ASC' ? 'bi bi-sort-alpha-up' : 'bi bi-sort-alpha-down-alt'"></i>
                                {{ sort == 'ASC' ? 'DESC' : 'ASC' }}
                              </button>
                            </div>
                            <div class="d-flex gap-3">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <a class="fs-6 text-success" href="javascript:void(0)" @click="() => { id = 'create', submit = null }" v-bind="attrs" v-on="on">
                                            <i class="ti ti-plus"></i>
                                        </a>
                                    </template>
                                    <small>Agregar registro</small>
                                </v-tooltip>
                            </div>
                        </div>
                        <div class="table-responsive border rounded">
                            <v-data-table class="elevation-1 align-middle text-nowrap mb-0" :headers="headers" item-key="id"
                                :items="submit == 'table' ? [] : items.data" :options.sync="options"
                                :server-items-length="items.total" :loading="submit == 'table'" :footer-props="{
                                    'items-per-page-options': [5, 10, 50, 100]
                                }">
                                <template v-slot:[`item.update`]="{ item }">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <a href="javascript:void(0)" @click="() => { id = 'update', submit = null, data = item }" class="link me-1" v-bind="attrs" v-on="on">
                                                <i class="ti ti-pencil fs-4 favourite-note"></i>
                                            </a>
                                        </template>
                                        <small>Editar</small>
                                    </v-tooltip>
                                </template>
                                <template v-slot:[`item.delete`]="{ item }">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <a href="javascript:void(0)" @click="() => { id = 'delete', submit = null, data = item }" class="link text-danger ms-2" v-bind="attrs" v-on="on">
                                                <i class="ti ti-trash fs-4 remove-note"></i>
                                            </a>
                                        </template>
                                        <small>Eliminar</small>
                                    </v-tooltip>
                                </template>
                            </v-data-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import AppCreate from '@/pages/users/models/Create'
import AppUpdate from '@/pages/users/models/Update'
import AppDelete from '@/pages/users/models/Delete'
export default {
  components: { AppCreate, AppUpdate, AppDelete },
  data () {
    return {
      // TABLE
      headers: [
        { text: '#', value: 'id', sortable: false },
        { text: 'Nombre', value: 'first_name', sortable: false },
        { text: 'Apellido', value: 'last_name', sortable: false },
        { text: 'Correo electrónico', value: 'email', sortable: false },
        { text: 'Editar', value: 'update', sortable: false },
        { text: 'Eliminar', value: 'delete', sortable: false }
      ],
      items: {
        data: [],
        total: 1
      },
      options: {},
      sort: 'DESC',
      search: '',
      // EVENTS
      submit: null,
      id: null,
      data: {},
      count: 0,
      cancelToken: null
    }
  },
  methods: {
    onInit: function () {
      this.submit = 'table'
      const { page, itemsPerPage } = this.options
      let query = {
        page: page,
        itemsPerPage: itemsPerPage,
        sortDesc: this.sort,
        search: this.search,
        role: 2
      }

      const source = this.$axios.CancelToken.source()
      this.cancelToken = source

      this.$axios({
        url: '/users',
        method: 'GET',
        params: query,
        cancelToken: source.token
      })
        .then((resp) => {
          this.items = resp.data
        })
        .finally((resp) => {
          this.submit = ''
        })
    },
    onSearch: function () {
      if (this.search.length > 0) {
        this.submit = 'table'
        if (this.cancelToken) {
          this.cancelToken.cancel('Solicitud cancelada')
        }
        this.onInit()
      }
    },
    onClear: function () {
      this.submit = 'table'
      this.search = ''
      this.sort = 'DESC'
      if (this.cancelToken) {
        this.cancelToken.cancel('Solicitud cancelada')
      }
      this.onInit()
    },
    onSort: function () {
      this.sort = this.sort === 'ASC' ? 'DESC' : 'ASC'
      this.submit = 'table'
      if (this.cancelToken) {
        this.cancelToken.cancel('Solicitud cancelada')
      }
      this.onInit()
    },
    onCreate: function (data) {
      this.submit = 'create'
      this.count++
      if (this.count !== 1) {
        return
      }
      data.role = 2
      this.$axios({
        url: '/users',
        method: 'POST',
        data: data
      })
        .then((resp) => {
          this.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
          this.id = null
          this.onInit()
        })
        .catch((err) => {
          let message = err.response ? err.response.data.message : err.message
          this.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
        })
        .finally((resp) => {
          this.count = 0
        })
    },
    onUpdate: function (data) {
      this.submit = 'update'
      this.count++
      if (this.count !== 1) {
        return
      }
      this.$axios({
        url: '/users/' + data.id,
        method: 'PUT',
        data: data
      })
        .then((resp) => {
          this.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
          this.id = null
          this.onInit()
        })
        .catch((err) => {
          let message = err.response ? err.response.data.message : err.message
          this.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
        })
        .finally((resp) => {
          this.count = 0
        })
    },
    onDelete: function (data) {
      this.count++
      if (this.count !== 1) {
        return
      }
      this.$axios({
        url: '/users/' + data.id,
        method: 'DELETE'
      })
        .then((resp) => {
          this.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
          this.id = null
          this.onInit()
        })
        .catch((err) => {
          let message = err.response ? err.response.data.message : err.message
          this.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
        })
        .finally((resp) => {
          this.count = 0
        })
    }
  },
  watch: {
    options: {
      handler () {
        if (this.cancelToken) {
          this.cancelToken.cancel('Solicitud cancelada')
        }
        this.submit = 'table'
        this.onInit()
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/Guia.vue